module.exports = __webpack_public_path__ + "img/mascot-fix.76feb340.png";